import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom';


function CompeListing(props) {
  return (
    // <Link path='/info'>
      <Link to={`/competition/${props.path}`} className='m-5 lg:w-[250px] w-[130px] md:w-[250px] mx-auto cursor-pointer'>
        <img src={require(`../../Assets/poster/${props.coverImg}`)} alt='' className=' justify-center items-center align-middle mb-[10px] rounded-xl hover:shadow-purple-500 shadow-lg'/>
        <h1 className='text-[JakartaSans] text-white font-bold text-[25px] text-center'>{props.name}</h1>
      </Link>
    // </Link>
  )
}

export default CompeListing